import { ACTION_TYPES, DEFAULT_LOADING_STATES } from '@constants';

const DEFAULT_STATES = {
  ...DEFAULT_LOADING_STATES,
  productAndServices: {},
};

export default (
  state = DEFAULT_STATES,
  action: { type: string; payload: string }
) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.CLEAR_PRODUCT_AND_SERVICES: {
      return {
        ...state,
        productAndServices: {},
      };
    }
    case ACTION_TYPES.SET_PRODUCT_AND_SERVICES_ACTION_LOADING: {
      return {
        ...state,
        isActionLoading: payload,
      };
    }
    case ACTION_TYPES.SET_PRODUCT_AND_SERVICES_GET_LOADING: {
      return {
        ...state,
        isGetLoading: payload,
      };
    }
    case ACTION_TYPES.GET_PRODUCT_AND_SERVICES_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isGetLoading: false,
        productAndServices: payload,
      };
    case ACTION_TYPES.GET_PRODUCT_AND_SERVICES_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isGetLoading: false,
      };
    case ACTION_TYPES.UPDATE_PRODUCT_AND_SERVICES_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isActionLoading: false,
        productAndServices: payload,
      };
    case ACTION_TYPES.UPDATE_PRODUCT_AND_SERVICES_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isActionLoading: false,
      };
    case ACTION_TYPES.CREATE_PRODUCT_AND_SERVICES_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: false,
        isActionLoading: false,
        productAndServices: payload,
      };
    case ACTION_TYPES.CREATE_PRODUCT_AND_SERVICES_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isActionLoading: false,
      };
    default:
      return state;
  }
};
